<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" id="_idContainer006" role="doc-dedication">
<p class="pl-center">To the men and women of the NYPD who protect and serve the vibrant city of New York.</p>
<p class="pl-center">To my fellow authors, Lynette, Dana, Laura, Lenora, Val, Sharon, Shirlee and Maggie—thank you for your support and patience with me.</p>
<p class="pl-center">To my editors, Emily Rodmell and Tina James—I  so appreciate all you do for me and the books.</p>
<p class="pl-center">And to my faithful friends Leah Vale and Jessie Smith for reading every word and believing in me.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?1e689636